import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import CoreValues from './components/CoreValues';
import IntegrationProcess from './components/IntegrationProcess';
import ProfessionalDirectory from './components/ProfessionalDirectory';
import KnowledgeHub from './components/KnowledgeHub';
import GlobalImpact from './components/GlobalImpact';
import Testimonials from './components/Testimonials';
import About from './components/About';
import Contact from './components/Contact';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import NewsTracking from './components/NewsTracking';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <CoreValues />
      <IntegrationProcess />
      <ProfessionalDirectory />
      <KnowledgeHub />
      <NewsTracking />
      <Contact />
      <Footer />
    </div>
  );
}
